import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { TranslatorConverter } from "src/TranslatorConverter";
import { ServerSideDataLoader, PaginationInfo, Enum, IEnumTranslator } from "uicomponents";
import { InvoiceDetailViewModel } from "../invoiceDetail/invoiceDetail-viewModel";
import  { InvoicesListView } from "./invoicesList-view"

export class InvoicesListViewModel extends WindowViewModel{
    public getTitle() {
        return 'لیست فاکتورها';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.invoiceStateEnumProvider = new InvoiceStateEnumProvider();
        this.invoicePaymentStateEnumProvider = new InvoicePaymentStateEnumProvider;
        this.invoiceShippingWarehouseStateEnumProvider = new InvoiceShippingWarehouseStateEnumProvider;
        this.invoiceDeliveryWarehouseStateEnumProvider = new InvoiceDeliveryWarehouseStateEnumProvider;
        this.invoiceTypeEnumProvider = new InvoiceTypeEnumProvider;
        this.invoicesLists = ObservableArray.create<InvoicesList>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),this.getPageSize());
        this.showSum = false;
        this.sum =0;
        this.refresh();
    }

    getPageSize(){
        return 30;
    }
    GetDefaultView(): View <ViewModel> {
        return new InvoicesListView();
    }
    public getTypeId(): string {
        return "VM-66F7F547-8288-451D-B19C-22699960D7B4"
    }
    public set invoiceStateEnumProvider(v: InvoiceStateEnumProvider) { this._invoiceStateEnumProvider = v; } public get invoiceStateEnumProvider(): InvoiceStateEnumProvider { return this._invoiceStateEnumProvider;} private _invoiceStateEnumProvider: InvoiceStateEnumProvider;
    public set invoicePaymentStateEnumProvider(v: InvoicePaymentStateEnumProvider) { this._invoicePaymentStateEnumProvider = v; } public get invoicePaymentStateEnumProvider(): InvoicePaymentStateEnumProvider { return this._invoicePaymentStateEnumProvider;} private _invoicePaymentStateEnumProvider: InvoicePaymentStateEnumProvider;
    public set invoiceTypeEnumProvider(v: InvoiceTypeEnumProvider) { this._invoiceTypeEnumProvider = v; } public get invoiceTypeEnumProvider(): InvoiceTypeEnumProvider { return this._invoiceTypeEnumProvider;} private _invoiceTypeEnumProvider: InvoiceTypeEnumProvider;
    public set invoiceShippingWarehouseStateEnumProvider(v: InvoiceShippingWarehouseStateEnumProvider) { this._invoiceShippingWarehouseStateEnumProvider = v; } public get invoiceShippingWarehouseStateEnumProvider(): InvoiceShippingWarehouseStateEnumProvider { return this._invoiceShippingWarehouseStateEnumProvider;} private _invoiceShippingWarehouseStateEnumProvider: InvoiceShippingWarehouseStateEnumProvider;
    public set invoiceDeliveryWarehouseStateEnumProvider(v: InvoiceDeliveryWarehouseStateEnumProvider) { this._invoiceDeliveryWarehouseStateEnumProvider = v; } public get invoiceDeliveryWarehouseStateEnumProvider(): InvoiceDeliveryWarehouseStateEnumProvider { return this._invoiceDeliveryWarehouseStateEnumProvider;} private _invoiceDeliveryWarehouseStateEnumProvider: InvoiceDeliveryWarehouseStateEnumProvider;
    public set invoicesLists(v: ObservableArray<InvoicesList>) { this._invoicesLists = v; } public get invoicesLists(): ObservableArray<InvoicesList> { return this._invoicesLists;} private _invoicesLists: ObservableArray<InvoicesList>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    public set sum(v: number) { this._sum = v; } public get sum(): number { return this._sum;} private _sum: number;
    public set showSum(v: boolean) { this._showSum = v; } public get showSum(): boolean { return this._showSum;} private _showSum: boolean;
    
    refreshClosePopups() {
        this.isShowingPopup = false;
        this.refresh();
    }
    
    refresh(){
        this.loader.refresh();
    }
    protected getServiceAddress():string{
        return '/Complex/SellServices/GetAllInvoices';
    }
    protected updateFilteringInformation(filteringInformation: any){
        if(filteringInformation.OrderInfo.length == 0)
        {
            let sort = {
                fieldName:'createdTime',
                order:'DESC',
                type:'date'
            };
            filteringInformation.OrderInfo = [sort];
        }
        return filteringInformation;
    }
    
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let serviceAddress = this.getServiceAddress();
            let result = await ServerConnection.callServer(serviceAddress,{
                FilteringInformation:this.updateFilteringInformation(filteringInformation)
            });
            this.invoicesLists.update(...result.Invoices.map((q,i)=>{
                let r = new InvoicesList(this);
                r.id = q.Id;
                r.rowNumber = i+1;
                r.customerName = q.CustomerName;
                r.sellerName = q.SellerName;
                r.cashierName = q.CashierName;
                r.receiverName = q.ReceiverName;
                r.creationTime = moment.utc(q.CreationTime);
                r.invoiceNumber = q.InvoiceNumber;
                r.parentInvoiceNumber = q.ParentInvoiceNumber;
                r.districtName = q.DistrictName;
                r.customerAccountBalance = Math.abs(q.CustomerAccountBalance);
                r.accountBalanceLabel = q.CustomerAccountBalance > 0 ? 'بدهکار' : 'بستانکار';
                r.totalPrice = q.TotalPrice;
                r.finalPrice = q.FinalPrice;
                r.totalDeficit = q.TotalDeficits;
                r.invoiceType = q.InvoiceType;
                r.warehouseState = q.WarehouseState;
                r.paymentState = q.PaymentState;
                r.isPrinted = q.IsPrinted;
                r.fromDistrict = q.IsFromRootDistrict == true ? 'اتوپارت' : 'شعب';
                r.state = q.State;
                r.shallPrint = (r.paymentState !=0 && r.paymentState !=1 && r.paymentState !=2) && r.isPrinted==false;

                return r;
            }));
            this.sum = this.invoicesLists.reduce((p,c)=>p+c.finalPrice,0);
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async showDetail (id:string) {
        let invoiceDetail = new InvoiceDetailViewModel(this);
        invoiceDetail.loadById(id);
        let result = await this.showPopup(invoiceDetail);
    }
}

export class InvoicesList extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:InvoicesListViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName;} private _customerName: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName;} private _sellerName: string;
    public set cashierName(v: string) { this._cashierName = v; } public get cashierName(): string { return this._cashierName;} private _cashierName: string;
    public set receiverName(v: string) { this._receiverName = v; } public get receiverName(): string { return this._receiverName;} private _receiverName: string;
    public set invoiceNumber(v: number) { this._invoiceNumber = v; } public get invoiceNumber(): number { return this._invoiceNumber;} private _invoiceNumber: number;
    public set parentInvoiceNumber(v: string) { this._parentInvoiceNumber = v; } public get parentInvoiceNumber(): string { return this._parentInvoiceNumber;} private _parentInvoiceNumber: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set customerAccountBalance(v: number) { this._customerAccountBalance = v; } public get customerAccountBalance(): number { return this._customerAccountBalance;} private _customerAccountBalance: number;
    public set accountBalanceLabel(v: string) { this._accountBalanceLabel = v; } public get accountBalanceLabel(): string { return this._accountBalanceLabel;} private _accountBalanceLabel: string;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice;} private _totalPrice: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice;} private _finalPrice: number;
    public set totalDeficit(v: number) { this._totalDeficit = v; } public get totalDeficit(): number { return this._totalDeficit;} private _totalDeficit: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set invoiceType(v: number) { this._invoiceType = v; } public get invoiceType(): number { return this._invoiceType;} private _invoiceType: number;
    public set state(v: number) { this._state = v; } public get state(): number { return this._state;} private _state: number;
    public set shallPrint(v: boolean) { this._shallPrint = v; } public get shallPrint(): boolean { return this._shallPrint;} private _shallPrint: boolean;
    public set warehouseState(v: number) { this._warehouseState = v; } public get warehouseState(): number { return this._warehouseState;} private _warehouseState: number;
    public set paymentState(v: number) { this._paymentState = v; } public get paymentState(): number { return this._paymentState;} private _paymentState: number;
    public set isPrinted(v: boolean) { this._isPrinted = v; } public get isPrinted(): boolean { return this._isPrinted;} private _isPrinted: boolean;
    public set isFromRootDistrict(v: boolean) { this._isFromRootDistrict = v; } public get isFromRootDistrict(): boolean { return this._isFromRootDistrict;} private _isFromRootDistrict: boolean;
    public set fromDistrict(v: string) { this._fromDistrict = v; } public get fromDistrict(): string { return this._fromDistrict;} private _fromDistrict: string;
    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    private _typedParent:InvoicesListViewModel;

    async edit() {
        this._typedParent.showDetail(this.id);        
    }
}

export class InvoiceStateEnumProvider extends Enum implements IEnumTranslator{
    constructor() {
        super();
        this.values = [0,1,2,3];
        this.translator = this;
        this.converter = new TranslatorConverter(); 
    }
    private converter:TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateInvoiceState(value);
    }
}

export class InvoicePaymentStateEnumProvider extends Enum implements IEnumTranslator{
    constructor() {
        super();
        this.values = [0,1,2,3,4,5];
        this.translator = this;
        this.converter = new TranslatorConverter(); 
    }
    private converter:TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateInvoicePaymentState(value);
    }
}

export class InvoiceShippingWarehouseStateEnumProvider extends Enum implements IEnumTranslator{
    constructor() {
        super();
        this.values = [0,1,2,3,4];
        this.translator = this;
        this.converter = new TranslatorConverter(); 
    }
    private converter:TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateInvoiceShippingWarehouseState(value);
    }
}

export class InvoiceDeliveryWarehouseStateEnumProvider extends Enum implements IEnumTranslator{
    constructor() {
        super();
        this.values = [0,1,2,3,4];
        this.translator = this;
        this.converter = new TranslatorConverter(); 
    }
    private converter:TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateInvoiceDeliveryWarehouseState(value);
    }
}

export class InvoiceTypeEnumProvider extends Enum implements IEnumTranslator{
    constructor() {
        super();
        this.values = [0,1,2,3];
        this.translator = this;
        this.converter = new TranslatorConverter(); 
    }
    private converter:TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateInvoiceType(value);
    }
}
